import type { EstimateHistoryPoint } from "../types";

export function MarketSparkline({ history }: { history: EstimateHistoryPoint[] }) {
  const values = history.map((point) => point.marketProbability).filter((value): value is number => typeof value === "number" && Number.isFinite(value));
  if (values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = Math.max(max - min, 0.01);
  const points = values.map((value, index) => `${(index / (values.length - 1)) * 100},${100 - ((value - min) / span) * 82 - 9}`).join(" ");
  return <svg className="market-sparkline" viewBox="0 0 100 100" preserveAspectRatio="none" role="img" aria-label="Market probability trend"><polyline points={points} /></svg>;
}
